export default "__VITE_ASSET__b936a00f__"